/// <amd-module name="Dashboards/DashboardView/src/components/body/EmptyDashboard" />
import * as React from "react";

import * as Resources from "Dashboards/DashboardView/Resources";

import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

import { IZeroDataProps, ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

export interface EmptyDashboardProps {
    onAddWidgetClick: () => void;
    canEditDashboard?: boolean;
}

export class EmptyDashboard extends VssComponent<EmptyDashboardProps> {
    public render(): JSX.Element | null {
        const buttonProps: Partial<IZeroDataProps> = {
            actionText: Resources.AddWidgetButtonText,
            actionType: ZeroDataActionType.ctaButton,
            onActionClick: this.props.onAddWidgetClick
        };

        return (
            <ZeroData
                primaryText={Resources.EmptyDashboard_PrimaryText}
                secondaryText={Resources.EmptyDashboard_SecondaryText}
                imagePath={getAssetLocation(this.context.pageContext, "ms.vss-dashboards-web/dashboard-view-content/images/empty-dashboard.svg")}
                imageAltText="" // Setting null alt-text (different from omitting alt-text) is equivalent to setting role="presentation"
                {...(this.props.canEditDashboard ? buttonProps : {})}
            />
        );
    }
}
